import React from 'react'
import './footer.css';
import Icon from '@mdi/react';
import {
    mdiInstagram,
    mdiFacebook,
    mdiMusicNote
} from '@mdi/js';
import { Divider, IconButton } from '@mui/material';
import logo from '../../img/banjirmission_logo.png';
export default function Footer() {
    const mDate = new Date();
    const social = [
        {
            icon: mdiInstagram,
            url: "https://www.instagram.com/banjirmission/"
        },
        {
            icon: mdiFacebook,
            url: "https://www.facebook.com/BanjirMission-105973832085557"
        },
        {
            icon: mdiMusicNote,
            url: "https://www.tiktok.com/@banjirmission"
        },
    ]
    const scrollToTop = () => {
        window.scrollTo(0, 0);
    }

    return (
        <div className="p-3 bg-black footer-container mx-auto w-100">
            <div className="d-flex flex-column mx-auto align-items-center">
                <img onClick={scrollToTop} className="logo-hover" src={logo} alt="" draggable={false} style={{ width: "100px" }} />
                <h3 className="text-white">Follow Us:</h3>
                <div className="flex-row">
                    {
                        social.map(x => {
                            return (<a href={x.url} key={x.url}>
                                <IconButton>
                                    <Icon path={x.icon}
                                        size={1}
                                        color="white" />
                                </IconButton>
                            </a>)
                        })
                    }
                </div>
            </div>
            <Divider style={{ color: "white" }} className="m-2" />
            <div className="w-100">
                <p className="text-white text-center">Banjir Mission | {mDate.getFullYear()} </p>
            </div>
        </div>
    )
}
